exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stuckdart[data-v-e931d11c]{display:flex;position:absolute;top:0;left:0;bottom:0;right:0;background-color:rgb(245 152 2/58%);z-index:1000;justify-content:center;align-items:center}.stuckdartMain h1[data-v-e931d11c]{font-size:5vw;text-align:center;background-color:#fff;padding:2vw;margin-top:-10vh;box-shadow:0 20px 50px #111;-webkit-animation:blinker-data-v-e931d11c 2s linear infinite;animation:blinker-data-v-e931d11c 2s linear infinite}@-webkit-keyframes blinker-data-v-e931d11c{25%{opacity:0}50%{opacity:1}}@keyframes blinker-data-v-e931d11c{25%{opacity:0}50%{opacity:1}}", ""]);

// exports
